import { useEffect, useRef, useState } from "react";
import { Send, Square, Paperclip } from "lucide-react";

export default function ChatInput({ onSend, onStop, streaming, disabled }) {
  const [value, setValue] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if (!streaming && !disabled) ref.current?.focus();
  }, [streaming, disabled]);

  const submit = () => {
    const v = value.trim();
    if (!v || streaming) return;
    onSend(v);
    setValue("");
    requestAnimationFrame(() => autosize(ref.current));
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="ai-input-wrap">
      <div className="ai-input">
        <button type="button" className="ai-input-attach" title="Attach (coming soon)" disabled>
          <Paperclip size={15} />
        </button>
        <textarea
          ref={ref}
          rows={1}
          className="ai-input-area"
          placeholder="Ask Brixigo AI anything — apply leave, check payroll, search employee…"
          value={value}
          onChange={(e) => { setValue(e.target.value); autosize(e.target); }}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
        {streaming ? (
          <button type="button" className="ai-input-stop" onClick={onStop} title="Stop">
            <Square size={14} />
          </button>
        ) : (
          <button
            type="button"
            className="ai-input-send"
            onClick={submit}
            disabled={disabled || !value.trim()}
            title="Send (Enter)"
          >
            <Send size={15} />
          </button>
        )}
      </div>
      <div className="ai-input-hint">Brixigo can make mistakes. Verify payroll & dates.</div>
    </div>
  );
}

function autosize(el) {
  if (!el) return;
  el.style.height = "auto";
  el.style.height = `${Math.min(el.scrollHeight, 180)}px`;
}
